module.exports = __webpack_public_path__ + "img/EA170_1-1.fc9c005d.jpg";